/**
 * DemoWelcomeModal.js — сцена 1 режиссуры демо «Кадрируем сцену».
 *
 * Одна карточка: рамка про Al Nakheel + кнопка «Поехали» / «Осмотрюсь сам».
 * Тексты — i18n (demo.tour.*). PostHog-разметка на кнопках.
 *
 * props: onStart(), onSkip()
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';

export default function DemoWelcomeModal({ onStart, onSkip }) {
  const { t } = useTranslation();
  const [logo, setLogo] = useState(null);

  // Подтягиваем логотип демо-орги (Al Nakheel) для шапки модала
  useEffect(() => {
    let cancelled = false;
    api.getOrganization()
      .then(org => { if (!cancelled) setLogo(org?.logo_full_path || org?.logo_small_path || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div
      data-ph-capture-attribute-component="demo_welcome_modal"
      style={{
        position: 'fixed', inset: 0, zIndex: 10001,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div style={{
        background: 'var(--bg2)', borderRadius: 16,
        maxWidth: 440, width: '100%', padding: '28px 26px 22px',
        boxShadow: '0 16px 56px rgba(0,0,0,0.32)',
        textAlign: 'center',
      }}>
        {logo ? (
          <img
            src={logo}
            alt="Al Nakheel"
            style={{ height: 56, width: 'auto', maxWidth: '70%', objectFit: 'contain', display: 'block', margin: '0 auto 14px' }}
          />
        ) : (
          <div style={{ height: 56, marginBottom: 14 }} aria-hidden="true" />
        )}
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>
          {t('demo.tour.welcomeTitle')}
        </div>
        <div style={{ fontSize: 15, color: 'var(--text2)', lineHeight: 1.5, marginBottom: 22 }}>
          {t('demo.tour.welcomeBody')}
        </div>
        <button
          onClick={onStart}
          data-ph-capture-attribute-action="tour_start"
          style={{
            width: '100%', background: 'rgba(99,102,241,1)', color: '#fff',
            border: 'none', padding: '13px 16px', borderRadius: 10,
            fontSize: 15, fontWeight: 600, cursor: 'pointer',
          }}
        >
          {t('demo.tour.start')}
        </button>
        <button
          onClick={onSkip}
          data-ph-capture-attribute-action="tour_skip"
          style={{
            marginTop: 10, background: 'none', border: 'none',
            color: 'var(--text3, #888)', fontSize: 13, cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          {t('demo.tour.skip')}
        </button>
      </div>
    </div>
  );
}
